import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);
const STORAGE_KEY = "tpg_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const keyOf = (product_id, size) => `${product_id}__${size}`;

  const addItem = (product, size) => {
    const price = size === "5ml" ? product.price_5ml : product.price_10ml;
    const key = keyOf(product.id, size);
    setItems((prev) => {
      const found = prev.find((i) => i.key === key);
      if (found) {
        return prev.map((i) => (i.key === key ? { ...i, qty: i.qty + 1 } : i));
      }
      return [
        ...prev,
        {
          key,
          product_id: product.id,
          brand: product.brand,
          name: product.name,
          size,
          price,
          qty: 1,
        },
      ];
    });
    setOpen(true);
  };

  const updateQty = (key, qty) => {
    if (qty <= 0) return removeItem(key);
    setItems((prev) => prev.map((i) => (i.key === key ? { ...i, qty } : i)));
  };

  const removeItem = (key) => {
    setItems((prev) => prev.filter((i) => i.key !== key));
  };

  const clear = () => setItems([]);

  const totals = useMemo(() => {
    const count = items.reduce((s, i) => s + i.qty, 0);
    const amount = items.reduce((s, i) => s + i.qty * i.price, 0);
    return { count, amount };
  }, [items]);

  return (
    <CartCtx.Provider
      value={{ items, addItem, updateQty, removeItem, clear, totals, open, setOpen }}
    >
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
